import "@fontsource/material-icons";
import "./styles/tokens.css";
import "./styles/frame.css";
import "./styles/hud.css";
import "./styles/hud-rails.css";
import "./styles/hud-collector.css";
import "./styles/panels.css";
import "./styles/profile-panel.css";
import "./styles/auto-panel.css";
import "./styles/crates-panel.css";
import "./styles/cosmetics-panel.css";
import "./styles/cosmetics-preview.css";
import "./styles/crate-reveal.css";
import "./styles/lucky-spark.css";
import "./styles/feedback.css";
import "./styles/arena.css";
import { mountOrbitForge } from "./app/mount";

const appRoot = document.querySelector<HTMLDivElement>("#app");

if (!appRoot) {
  throw new Error("Orbit requires an #app mount node.");
}

mountOrbitForge(appRoot);
